import React from 'react'
import styled from 'styled-components'
import { text } from '../styles/mixins/text'

type Props = {
    title: string
    description?: string
    className?: string
    actionElement?: JSX.Element
}

export const PageLabel = (props: Props): JSX.Element => {
    const { className, title: headerText, description: subheaderText, actionElement } = props

    return (
        <Container className={className}>
            <Row>
                <Column>
                    <Header>{headerText}</Header>
                    {subheaderText && <SubHeader>{subheaderText}</SubHeader>}
                </Column>
                {actionElement}
            </Row>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-flow: column nowrap;
`

const Header = styled.h1`
    ${text('header', 'primary', 'text')}
`

const SubHeader = styled.h2`
    ${text('paragraph', 'secondary', 'text')}
`

const Row = styled.div`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
`

const Column = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
`
